var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personalize-vue" },
    [
      _vm.personalized
        ? _c("div", { staticClass: "personalize-wrapper" }, [
            _c("div", { staticClass: "personalize-wrapper-header" }, [
              _c("h3", {
                domProps: { textContent: _vm._s(_vm.wrapper_title) }
              }),
              _vm._v(" "),
              _c("span", { domProps: { textContent: _vm._s(_vm.pz_price) } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "personalize-wrapper-selections" }, [
              _c(
                "ul",
                _vm._l(this.pzFormData, function(selectedLine) {
                  return _c("li", [
                    _vm._v(
                      "\n          " +
                        _vm._s(selectedLine.line_desc) +
                        ": " +
                        _vm._s(_vm.transformVal(selectedLine)) +
                        "\n        "
                    )
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "personalize-wrapper-confirmed" }, [
              _c("input", {
                attrs: { type: "checkbox", id: "pz-confirmed" },
                on: { click: _vm.verifySpelling }
              }),
              _vm._v(" "),
              _c("label", {
                attrs: { for: "pz-confirmed" },
                domProps: { textContent: _vm._s(_vm.wrapper_policy) }
              })
            ]),
            _vm._v(" "),
            _c("a", {
              staticClass: "link-primary",
              domProps: { textContent: _vm._s(_vm.wrapper_btn_edit) },
              on: {
                click: function($event) {
                  return _vm.viewForm()
                }
              }
            })
          ])
        : _c("div", { staticClass: "personalize-wrapper" }, [
            _c("div", { staticClass: "personalize__form--header" }, [
              _c("div", [
                _c("span", [_vm._v("pz")]),
                _vm._v(" "),
                _c("h3", {
                  domProps: { textContent: _vm._s(_vm.wrapper_title) }
                })
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "_price",
                domProps: { textContent: _vm._s(_vm.pz_price) }
              })
            ]),
            _vm._v(" "),
            _vm.hasNoPZ
              ? _c("div", { staticClass: "personalize-wrapper-options" }, [
                  _c("ul", [
                    _c("li", [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          name: "start_pz",
                          id: "no_personalization",
                          value: "0",
                          checked: ""
                        },
                        on: { click: _vm.selectOpt }
                      }),
                      _vm._v(" "),
                      _c("label", {
                        attrs: { for: "no_personalization" },
                        domProps: { textContent: _vm._s(_vm.wrapper_opt_no) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          name: "start_pz",
                          id: "personalized_start",
                          value: "1"
                        },
                        on: { click: _vm.selectOpt }
                      }),
                      _vm._v(" "),
                      _c("label", {
                        attrs: { for: "personalized_start" },
                        domProps: { textContent: _vm._s(_vm.wrapper_opt_yes) }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.wrapper_opt_yes_surfix)
                        }
                      })
                    ])
                  ])
                ])
              : _vm._e()
          ]),
      _vm._v(" "),
      _c("PzForm", {
        attrs: { sku: _vm.pz_sku, show: _vm.started },
        on: {
          priceStatus: _vm.changePrice,
          modalClose: _vm.closeModal,
          modalStatus: _vm.changeModalStatus,
          personalizedStatus: _vm.changePZStatus
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!../assets/js/personalize/app.vue?vue&type=template&id=0a137e4e&
// module id = 81
// module chunks = 0